

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETCASHPURCHASESBYCREATOR= createAsyncThunk(
  "getCashPurchasesByCreator/getCashPurchasesByCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getCashPurchasesByCreatorSlice = createSlice({
  name: "getCashPurchasesByCreatorSlice",
  initialState: {
    getCashPurchasesByCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetCashPurchasesByCreator: (state) => {
        state.getCashPurchasesByCreator.loading = false
        state.getCashPurchasesByCreator.error = false
        state.getCashPurchasesByCreator.data = []
        state.getCashPurchasesByCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCASHPURCHASESBYCREATOR.fulfilled, (state, action) => {
      state.getCashPurchasesByCreator = {
        ...state.getCashPurchasesByCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCASHPURCHASESBYCREATOR.pending, (state, action) => {
      state.getCashPurchasesByCreator = {
        ...state.getCashPurchasesByCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCASHPURCHASESBYCREATOR.rejected, (state, action) => {
      state.getCashPurchasesByCreator = {
        ...state.getCashPurchasesByCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getCashPurchasesByCreatorAction = {
    GETCASHPURCHASESBYCREATOR,
};

export { getCashPurchasesByCreatorAction };
export default getCashPurchasesByCreatorSlice.reducer;
export const {setInitialStateOfgetCashPurchasesByCreator} = getCashPurchasesByCreatorSlice.actions
